import * as tslib_1 from "tslib";
import '../index.global.scss';
import theme from './theme.scss';
export default tslib_1.__assign({}, theme);
//# sourceMappingURL=index.js.map